module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/logo-coj-en-27c2e4f6bf16203ec5724b41518aa464.svg";